import React from 'react'
import { useEffect } from 'react'
import PropTypes from 'prop-types'
import "./FrameSection.scss"

const FrameSection = ({ frameSection }) => {
  useEffect(() => {
    const frameSectionContainer = document.getElementById(`framesection-container-${frameSection.id}`)
    const codeFrameSection = frameSection.code
    .replace(/width="[^"]*"/g, 'width="100%"')
    .replace('style="', 'style="max-width:100%;')
    
    frameSectionContainer.innerHTML = codeFrameSection
  }, [frameSection.id, frameSection.code])

  return (
    <div className="mb-5 container">
      <h5 className='title-frame-section'>{frameSection.title}</h5>
      <div
        id={`framesection-container-${frameSection.id}`}
        className="w-100 shadow rounded"
      ></div>
    </div>
  )
}

export default FrameSection

FrameSection.propTypes = {
  frameSection: PropTypes.object.isRequired
}